
import * as React from 'react';
import * as PropTypes from 'prop-types'

import { ITranslationContext } from '../../../../translations';
import { clickHandler } from '../../../../utils/util';
import { ProdVariant } from './types';
import { DateFormat } from "../../../../store/pages/venues/types";

interface ProductVariantsProps {
    variants: ProdVariant[];
    dateFormat: DateFormat;
    editVariant: (key: string) => void;
    addVariant: () => void;
}

const ProductVariants = (props: ProductVariantsProps, context: ITranslationContext) => {
    const { t } = context;
    const { variants, dateFormat, editVariant, addVariant } = props;

    return (<>
            <label>{t('ProductForm:productVariants')}</label>
            <table className='table table-super-condensed table-borderless' style={({ width: 'auto', margin: '0 0 15px 0' })}>
                {variants.length > 0
                    ? <thead>
                    <tr>
                        <th>{t('ProductVariant:name')}</th>
                        <th>{t('ProductVariant:availableFrom')}</th>
                        <th>{t('ProductVariant:availableTo')}</th>
                    </tr>
                    </thead>
                    : null}
                <tbody>
                {variants.map(v => {
                    return (<tr key={v.key} onClick={e => clickHandler(e, () => editVariant(v.key))}>
                        <td className='btn-link btn-no-padding'>{v.name.value}</td>
                        <td className='btn-link btn-no-padding text-center'>{v.availableFrom.value.toDate().toShortDateString(dateFormat)}</td>
                        <td className='btn-link btn-no-padding text-center'>{v.availableTo.value ? v.availableTo.value.toDate().toShortDateString(dateFormat) : null}</td>
                    </tr>)
                })}
                </tbody>
                <tfoot>
                <tr>
                    <td colSpan={4}>
                        <button className='btn btn-primary' onClick={e => clickHandler(e, addVariant)}>{t('ProductVariant:addVariant')}</button>
                    </td>
                </tr>
                </tfoot>
            </table>
        </>
    );
}

ProductVariants.contextTypes = {
    t: PropTypes.func
}

export default ProductVariants;